import {
  shiftAuctionBidBodySchema,
  shiftAuctionInstantBookContract,
  type ShiftAuctionInstantBookResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type ComputedArrivalData } from "@src/appV2/redesign/ArrivalTime/computeArrivalData";
import { toShiftAuctionBidBody } from "@src/appV2/redesign/Shift/ShiftAuction/utils/toShiftAuctionBidBody";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";

const SHIFT_AUCTION_INSTANT_BOOK_PATH = "/shift-auction-instant-book";
const SHIFT_AUCTION_INSTANT_BOOK_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}${SHIFT_AUCTION_INSTANT_BOOK_PATH}`;

interface InstantBookShiftAuctionRequest {
  shiftAuctionId: string;
  bidAmount: number;
  computedArrivalData: ComputedArrivalData | undefined;
}

export function useInstantBookShiftAuction(
  options: UseMutationOptions<
    ShiftAuctionInstantBookResponse,
    AxiosError,
    InstantBookShiftAuctionRequest
  > = {}
) {
  return useMutation({
    mutationFn: async ({
      shiftAuctionId,
      bidAmount,
      computedArrivalData,
    }: InstantBookShiftAuctionRequest) => {
      const response = await post({
        url: SHIFT_AUCTION_INSTANT_BOOK_URL,
        data: toShiftAuctionBidBody({ shiftAuctionId, bidAmount, computedArrivalData }),
        requestSchema: shiftAuctionBidBodySchema,
        responseSchema: shiftAuctionInstantBookContract.postShiftAuctionInstantBook.responses[200],
      });

      return response.data as ShiftAuctionInstantBookResponse;
    },
    ...options,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.POST_SHIFT_AUCTION_INSTANT_BOOK_FAILURE,
      ...options.meta,
    },
  });
}
